import React, { FunctionComponent } from 'react'
import { FormattedMessage, FormattedTime } from 'react-intl'

import styled, { useTheme } from 'styled-components/native'

import { BodyText } from '../../atoms/bodyText/BodyText'
import { Divider } from '../../atoms/divider/Divider'
import { HoverActionContainer } from '../../organisms/hoverActionContainer/HoverActionContainer'
import { BodyTextSize } from '../../styles/typeStyles'
import { tID } from '../../utils/utils'
import { HoverActionItem } from '../hoverActions/HoverActions'

export type ProviderAgendaItemProps = {
  id: number
  appointmentDate: Date
  clientName: React.ReactNode
  appointmentInfo: React.ReactNode
  hoverActions: HoverActionItem[]
  onPress?: () => void
  completedOnboardingForms?: boolean
  badges?: React.ReactNode | React.ReactNode[]
  isLastItem?: boolean
}

const Container = styled(HoverActionContainer)(({ theme }) => ({
  paddingHorizontal: theme.spacing['16px'],
}))

const ContentRow = styled.View(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  paddingVertical: theme.spacing['16px'],
  gap: theme.spacing['16px'],
}))

const RightColumn = styled.View({
  flex: 1,
  flexDirection: 'column',
  alignItems: 'flex-start',
})

const ClientInfoContainer = styled.View(({ theme }) => ({
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: theme.spacing['4px'],
  width: '100%',
}))

const ClientNameRow = styled.View(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing['8px'],
}))

export const ProviderAgendaItem: FunctionComponent<ProviderAgendaItemProps> = ({
  id: _id,
  appointmentDate,
  clientName,
  appointmentInfo,
  hoverActions,
  onPress,
  completedOnboardingForms = true,
  badges,
  isLastItem = false,
}) => {
  const { colors } = useTheme()

  return (
    <Container items={hoverActions} onPress={onPress} testID={tID('ProviderAgendaItem')}>
      <ContentRow>
        <BodyText text={<FormattedTime value={appointmentDate} hour='numeric' minute='2-digit' hour12={true} />} />
        <RightColumn>
          <ClientInfoContainer>
            <ClientNameRow>
              <BodyText text={clientName} />
              {badges}
            </ClientNameRow>
            {!completedOnboardingForms && (
              <BodyText
                size={BodyTextSize.SMALL}
                color={colors.textWarning}
                text={
                  <FormattedMessage
                    defaultMessage="Hasn't completed Lyra's onboarding form"
                    description='Warning shown on a scheduled appointment when the client has not finished onboarding'
                  />
                }
              />
            )}
            <BodyText size={BodyTextSize.CAPTION} color={colors.textSecondary} text={appointmentInfo} />
          </ClientInfoContainer>
        </RightColumn>
      </ContentRow>
      {!isLastItem && <Divider />}
    </Container>
  )
}
